import  { IngredientsPage } from './pages/IngredientsPage'
import  { CreateIngredientPage } from './pages/CreateIngredientPage'
import  { UpdateIngredientPage } from './pages/UpdateIngredientPage'

export const ingredientsRoutes = {
  path: 'ingredients',
  children: [{
    path: '',
    element: <IngredientsPage />,
    children: [{
      path: 'create',
      element: <CreateIngredientPage />,
    }, {
      path: ':id',
      element: <UpdateIngredientPage />,
    }],
  }],
};
